import { useCallback } from "react";
import { useCalendlyAdapterAxiosInstance } from "./useCalendlyAdapterAxiosInstance.ts";
import dayjs from "dayjs";
import { useWithLoading } from "../UI/Loading/useWithLoading.ts";
import { AvailabilitySlot } from "../Closer/AvailabilitySlot.tsx";
export type AvailableUserDTO = {
  email: string;
  uri: string;
};

export function useCheckCalendlyAvailability() {
  const axiosInstance = useCalendlyAdapterAxiosInstance();
  const { withLoading, loading } = useWithLoading<AvailabilitySlot[]>();
  const checkAvailabilityCall = useCallback(
    async ({
      fromIncl,
      toIncl,
      filteredUsers,
    }: {
      fromIncl: Date;
      toIncl: Date;
      filteredUsers?: string[];
    }) => {
      const formattedFromIncl = dayjs(fromIncl).format();
      const formattedToIncl = dayjs(toIncl).format();
      let formattedFilteredUsers = "";
      if (filteredUsers && filteredUsers.length > 0)
        formattedFilteredUsers = `&filteredEmails=${filteredUsers.join(",")}`;

      const { data } = await axiosInstance.get<
        {
          slotStart: string;
          slotEnd: string;
          availableUsers: AvailableUserDTO[];
        }[]
      >(
        `/organization-availability/get?fromIncl=${encodeURIComponent(formattedFromIncl)}&toIncl=${encodeURIComponent(formattedToIncl)}${formattedFilteredUsers}`,
      );

      return data;
    },
    [axiosInstance],
  );

  const checkCalendlyAvailability = useCallback(
    async ({
      fromIncl,
      toIncl,
      filteredUsers,
    }: {
      fromIncl: Date;
      toIncl: Date;
      filteredUsers?: string[];
    }) => {
      return await withLoading(() =>
        checkAvailabilityCall({ fromIncl, toIncl, filteredUsers }),
      );
    },
    [withLoading, checkAvailabilityCall],
  );

  return {
    checkCalendlyAvailability,
    loading,
  };
}
